import { tv } from 'tailwind-variants';

import { Dropdown } from '@frontendmentorio/design-system-v2';

const styles = tv({
  base: [
    'flex',
    'flex-col',
    'font-secondary',
    'font-semibold',
    'grow',
    'p-4',
    'relative',
    'text-neutral-500',
    'text-lg',
    'text-start',
    'whitespace-nowrap',
    'after:absolute',
    'after:bg-neutral-300',
    'after:h-[2px]',
    'after:left-0',
    'after:top-[calc(100%-2px)]',
    'after:transition-colors',
    'after:w-full',
    'first:pl-0',
  ],
  variants: {
    isActive: {
      false: ['hover:after:bg-neutral-500'],
      true: ['text-blue-500', 'after:bg-blue-500', 'after:opacity-100'],
    },
  },
});

export default function Tabs({ activeTab, onChange: handleChange, options }) {
  return (
    <>
      <Dropdown
        ariaLabel="Select challenge tab"
        className="mb-6 tablet:hidden"
        onChange={handleChange}
        options={options}
        value={activeTab}
      />

      <div className="container-xl hidden pb-8 tablet:flex">
        <button
          className={styles({ isActive: activeTab === '' })}
          onClick={() => handleChange('')}
        >
          <span className="font-bold text-sm tracking-widest uppercase">
            Step 1
          </span>

          <span>Start challenge</span>
        </button>

        <button
          className={styles({ isActive: activeTab === 'downloads' })}
          onClick={() => handleChange('downloads')}
        >
          <span className="font-bold text-sm tracking-widest uppercase">
            Step 2
          </span>

          <span>Download assets</span>
        </button>

        <button
          className={styles({ isActive: activeTab === 'submit' })}
          onClick={() => handleChange('submit')}
        >
          <span className="font-bold text-sm tracking-widest uppercase">
            Step 3
          </span>

          <span>Submit solution</span>
        </button>

        <button
          className={styles({ isActive: activeTab === 'solutions' })}
          onClick={() => handleChange('solutions')}
        >
          <span className="font-bold text-sm tracking-widest uppercase">
            Step 4
          </span>

          <span>Review solutions</span>
        </button>
      </div>
    </>
  );
}
